import { DateTimeInterval } from '@csp/csp-common-model';
import { zonedMax, zonedMin } from '@csp/csp-common-date-util';
import { UserMetricCount } from './UserMetricCount';

export type UserMetricCounts = {
  countPerUser: UserMetricCount[];
  totalCount: number;
  totalDateInterval?: DateTimeInterval;
};

const from = (countPerUser: UserMetricCount[]): UserMetricCounts => {
  const { totalCount, totalDateInterval } = countPerUser.reduce<Omit<UserMetricCounts, 'countPerUser'>>(
    (prev, current) => ({
      totalCount: prev.totalCount + current.count,
      totalDateInterval: {
        start: zonedMin([current.dateInterval.start, prev.totalDateInterval?.start]),
        end: zonedMax([current.dateInterval.end, prev.totalDateInterval?.end]),
      },
    }),
    {
      totalCount: 0,
    },
  );
  return {
    countPerUser,
    totalCount,
    totalDateInterval,
  };
};

export const UserMetricCounts = { from };
